export default "__VITE_ASSET__977646ab__"